"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ScenarioItem = void 0;

var _react = _interopRequireWildcard(require("react"));

var _SituationsListOverviewStyle = _interopRequireDefault(require("./../css/SituationsListOverviewStyle"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ScenarioItem = function ScenarioItem(_ref) {
  var scenario = _ref.scenario,
      index = _ref.index,
      selection = _ref.selection,
      currentSituations = _ref.currentSituations;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      image = _useState2[0],
      setimage = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      title = _useState4[0],
      settitle = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      noImageTitle = _useState6[0],
      setNoImageTitle = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      alreadySelected = _useState8[0],
      setAlreadySelected = _useState8[1];

  var changeScenarioHandler = function changeScenarioHandler() {
    scenario.scenarioIndex = index + 1;
    typeof dataLayer !== 'undefined' ? dataLayer.push({
      'event': 'GAevent',
      'eventCategory': ' All Link & Button Clicks',
      'eventAction': 'Scenario selected',
      'eventLabel': "".concat(scenario.title.html.html.replace(/<.*?>/g, '').trim(), " \u2013 ").concat(selection, " selection")
    }) : null;
  };

  (0, _react.useEffect)(function () {
    if (scenario.overviewImage && scenario.overviewImage.html.html) {
      setimage(scenario.overviewImage.html.html.replace('data-src', 'src'));
    }

    if (scenario.title && scenario.title.html.html) {
      settitle(scenario.title.html.html);
    }

    if (scenario.noImageTitle && scenario.noImageTitle.html.html) {
      setNoImageTitle(scenario.noImageTitle.html.html);
    }

    var isCurrentScenarioSelected = currentSituations.find(function (situation) {
      return situation.scenarioIndex === scenario.scenarioIndex;
    });
    isCurrentScenarioSelected ? setAlreadySelected(true) : setAlreadySelected(false);
  }, [scenario]);
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    className: "scenario-overview item off-anchor-style ".concat(image ? '' : 'no-image', " ").concat(scenario.isSelected ? 'selected' : ''),
    key: index,
    onClick: function onClick() {
      return changeScenarioHandler();
    },
    to: {
      pathname: "/scenario-".concat(index + 1),
      state: {
        scenarioIndex: index + 1,
        alreadySelected: alreadySelected
      }
    }
  }, image && /*#__PURE__*/_react["default"].createElement("div", {
    className: "image",
    dangerouslySetInnerHTML: {
      __html: image
    }
  }), noImageTitle && /*#__PURE__*/_react["default"].createElement("div", {
    className: "no-image-title",
    dangerouslySetInnerHTML: {
      __html: noImageTitle
    }
  }), title && /*#__PURE__*/_react["default"].createElement("div", {
    className: "title",
    dangerouslySetInnerHTML: {
      __html: title
    }
  }));
};

exports.ScenarioItem = ScenarioItem;

var SituationsListOverview = function SituationsListOverview(_ref2) {
  var scenarios = _ref2.scenarios,
      viewData = _ref2.viewData,
      currentSituations = _ref2.currentSituations;

  var _useState9 = (0, _react.useState)('First'),
      _useState10 = _slicedToArray(_useState9, 2),
      selection = _useState10[0],
      setSelection = _useState10[1];

  (0, _react.useEffect)(function () {
    {
      currentSituations.length === 0 && typeof dataLayer !== 'undefined' && dataLayer.push({
        'event': 'vpv',
        'vpv': "".concat(window.location.href, "/scenario-selection-1/step2")
      });
    }
    {
      currentSituations.length === 1 && typeof dataLayer !== 'undefined' && (dataLayer.push({
        'event': 'vpv',
        'vpv': "".concat(window.location.href, "/scenario-selection-2/step3")
      }), setSelection('Second'));
    }
    {
      currentSituations.length === 2 && typeof dataLayer !== 'undefined' && (dataLayer.push({
        'event': 'vpv',
        'vpv': "".concat(window.location.href, "/scenario-selection-3/step4")
      }), setSelection('Third'));
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_SituationsListOverviewStyle["default"], null, (viewData === null || viewData === void 0 ? void 0 : viewData.listOverview) && (viewData === null || viewData === void 0 ? void 0 : viewData.listOverview.overviewHeadline.html.html) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, currentSituations.length === 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "scenarios-overview title",
    dangerouslySetInnerHTML: {
      __html: viewData.listOverview.overviewHeadline.html.html
    }
  }), currentSituations.length === 1 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "scenarios-overview title"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: viewData.listOverview.chooseScenarioHeadline.html.html
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "/review-answers",
    className: "link"
  }, viewData.savedView.answersButton.html.html))), currentSituations.length >= 2 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "scenarios-overview title"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: viewData.listOverview.chooseOneMoreScenarioHeadline.html.html
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "/review-answers",
    className: "link"
  }, viewData.savedView.answersButton.html.html)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "scenarios-overview"
  }, scenarios && scenarios.map(function (scenario, index) {
    return /*#__PURE__*/_react["default"].createElement(ScenarioItem, {
      scenario: scenario,
      key: index,
      index: index,
      selection: selection,
      currentSituations: currentSituations
    });
  })));
};

var _default = SituationsListOverview;
exports["default"] = _default;